import { get } from 'lodash/fp'

export const getIdentificationId = get('customerV3.data[0].identifications.identification_id')
export const getGivenName = get('customerV3.data[0].individuals.given_name')
export const getFamilyName = get('customerV3.data[0].individuals.family_name')
export const getAdditionalName = get('customerV3.data[0].individuals.additional_name')
export const getNationality = get('customerV3.data[0].individuals.nationality')
export const getBirthday = get('customerV3.data[0].individuals.date_of_birth')
export const getCustomerisLoading = get('customerV3.loading')
